// extracted by mini-css-extract-plugin
export default {"hotspotImage":"style_hotspotImage__tvJUS","hotspot":"style_hotspot__ffEUD","placeholder":"style_placeholder__C+K9b"};